import { render, staticRenderFns } from "./IrNotification.vue?vue&type=template&id=4a75c73b&"
import script from "./IrNotification.vue?vue&type=script&lang=js&"
export * from "./IrNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports